module.exports = __webpack_public_path__ + "img/nofoto.e867034e.png";